import template from './HighDemand.jade';
import highDemandCtrl from './HighDemand.controller';

export const HighDemand = () => {
  return {
    template,
    scope: {},
    bindToController: {
      demandCoefficient: '=',
    },
    controller: highDemandCtrl,
    controllerAs: 'highDemandCtrl',
    replace: true,
  };
};
